import Link from "next/link";
import Image from "next/image";

import * as styledElements from "./FooterStyles";
import {
  ABOUT_US,
  BLOG,
  PRESS,
  CONTACT,
  PRIVACY,
  PRESS_NSF_PHASE_I,
  NEWSLETTER,
} from "../../constants/routes";

const LINK_INFO = [
  {
    href: ABOUT_US,
    label: "About",
  },
  {
    href: BLOG,
    label: "Blog",
  },
  {
    href: PRESS,
    label: "Press",
  },
  {
    href: CONTACT,
    label: "Contact",
  },
  {
    href: NEWSLETTER,
    label: "Newsletter",
  },
  {
    href: PRIVACY,
    label: "Privacy",
  },
];

const Footer = () => {
  return (
    <styledElements.Footer>
      {LINK_INFO.map((link) => (
        <div key={link.href}>
          <styledElements.TextLink
            href={link.href}
            passHref={true}
            key={link.href}
          >
            {link.label}
          </styledElements.TextLink>
        </div>
      ))}
      <styledElements.TextArea>
        <span>© Copyright {new Date().getFullYear()} FlashPCB</span>
        <Link href={PRESS_NSF_PHASE_I} passHref={true}>
          <Image
            src="/images/NSF_Official_logo.svg"
            alt="NSF logo"
            width="45"
            height="45"
          />
        </Link>
      </styledElements.TextArea>
    </styledElements.Footer>
  );
};

export default Footer;
